import { useMemo } from "react";

import { normalizeAssessmentRecords, applyDerivedFields } from "./assessmentDataTransforms";
import { useRawAssessments } from "./useRawAssessments";

export function useAssessmentsData(clientId?: string, clientAgeInYears?: number | null) {
  const { rawAssessments, assessmentsLoading, cardStatusByType, ...rest } =
    useRawAssessments(clientId);

  const normalizedAssessments = useMemo(
    () => normalizeAssessmentRecords(rawAssessments || []),
    [rawAssessments]
  );

  const assessmentsWithDerived = useMemo(
    () => applyDerivedFields(normalizedAssessments, clientAgeInYears ?? null),
    [normalizedAssessments, clientAgeInYears]
  );

  return {
    clientAssessments: assessmentsWithDerived,
    assessmentsLoading,
    cardStatusByType,
    ...rest,
    // Per requirements, API failures should fall back to empty state with no error surface.
    isError: false,
  };
}
